export var LoadableStatus;
(function (LoadableStatus) {
    LoadableStatus["Idle"] = "idle";
    LoadableStatus["Fetching"] = "fetching";
    LoadableStatus["Fetched"] = "fetched";
    LoadableStatus["Error"] = "error";
})(LoadableStatus || (LoadableStatus = {}));
export function idle() {
    return { status: LoadableStatus.Idle, data: undefined };
}
export function assertFetched(loadable, message) {
    if (message === void 0) { message = ''; }
    if (loadable.status !== LoadableStatus.Fetched) {
        if (process.env.NODE_ENV !== 'production') {
            throw new Error("Assertion failed" + (message && ": " + message));
        }
        return false;
    }
    return true;
}
